import { render, staticRenderFns } from "./editSellerProfile.vue?vue&type=template&id=2f65241c&"
import script from "./editSellerProfile.vue?vue&type=script&lang=js&"
export * from "./editSellerProfile.vue?vue&type=script&lang=js&"
import style0 from "./editSellerProfile.vue?vue&type=style&index=0&id=2f65241c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports